(() => {
  if (customElements.get('hh-subcategories')) return;
  customElements.define('hh-subcategories', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const list = this.querySelector('.hh-subcategories__list');
      const previous = this.querySelector('[data-hh-previous]');
      const next = this.querySelector('[data-hh-next]');
      if (!list || !previous || !next) return;
      const update = () => {
        this.frame = null;
        const maximum = Math.max(0, list.scrollWidth - list.clientWidth);
        const position = Math.abs(list.scrollLeft);
        previous.hidden = previous.disabled = maximum < 2 || position < 2;
        next.hidden = next.disabled = maximum < 2 || position >= maximum - 2;
      };
      const schedule = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      };
      const move = direction => {
        const item = list.firstElementChild;
        if (!item) return;
        const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap);
        const amount = Math.max(1, Math.floor(list.clientWidth / step)) * step;
        const rtl = getComputedStyle(list).direction === 'rtl' ? -1 : 1;
        list.scrollBy({left: amount * direction * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', event => { event.stopPropagation(); move(-1); }, {signal});
      next.addEventListener('click', event => { event.stopPropagation(); move(1); }, {signal});
      list.addEventListener('scroll', schedule, {signal, passive: true});
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(list);
      if (list.firstElementChild) this.observer.observe(list.firstElementChild);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
})();
